import type { Labels } from "@/lib/labels/types";

export { getCountryFlagUrl } from "@/utilities/country";

/** Get the single-letter initial for a competition type (uses localized name) */
export function getCompetitionTypeInitial(type: string | undefined, labels: Labels): string {
    if (!type) return "";
    const fullName = getCompetitionTypeLabel(type, labels);
    return fullName.charAt(0).toUpperCase();
}

/** Get the localized full name for a competition type */
export function getCompetitionTypeLabel(type: string | undefined, labels: Labels): string {
    if (!type) return "";
    const t = type.toUpperCase();
    switch (t) {
        case "LEAGUE":
            return labels.competitions.types.league;
        case "CUP":
            return labels.competitions.types.cup;
        case "TOURNAMENT":
            return labels.competitions.types.tournament;
        case "FRIENDLY":
            return labels.competitions.types.friendly;
        default:
            return type;
    }
}

